import {
    server
} from "@/api";

const prefix = 'api/auth';


export const login = async (user) => {
    return await server().post(`${prefix}/login`, user)
}

export const register = async (user) => {
    return await server().post(`${prefix}/register`, user);
}

export const current = async () => {
    return await server().get(`${prefix}/current`)
}

export const logout = async () => {
    return await server().post(`${prefix}/logout`)
}

export const actAsRole = async (role) => {
    return await server().post(`${prefix}/act-as-role/${role}`)
}

export default {
    login,
    register,
    current,
    logout,
    actAsRole
}